export enum LearningMode {
  normal,
  restartOnlyIncorrectTerms,
  restartFromLearningHistory,
}
